import apiClient from './apiClient';

export async function getPublishedJobs() {
  const response = await apiClient.get('/api/jobs');
  return response.data;
}

export async function getPublishedJob(categorySlug, jobSlug) {
  const response = await apiClient.get(`/api/jobs/${categorySlug}/${jobSlug}`);
  return response.data;
}
